// extracted by mini-css-extract-plugin
export default {"card":"PostList_card__VC1Co","link":"PostList_link__l9Eqw"};